// Copyright (c) Move Closer 2023.

export const units = Object.freeze({
  ml: { volume: 100, label: 'ml' },
  g: { volume: 100, label: 'g' },
  'szt.': { volume: 1, label: 'szt.' },
  szt: { volume: 1, label: 'szt.' },
  sztuki: { volume: 1, label: 'szt.' },
  sztuk: { volume: 1, label: 'szt.' },
  pcs: { volume: 1, label: 'pcs' },
  'pc.': { volume: 1, label: 'pcs' },
  zestaw: { volume: 1, label: 'zestaw' }
})
